const AvailableFeatures = Object.freeze({
  REFINEMENTS_PER_TRIP: 'refinements_per_trip',
  TRIPS: 'trips',
} as const);

export type AvailableFeatures = (typeof AvailableFeatures)[keyof typeof AvailableFeatures];
export const allAvailableFeatures: [AvailableFeatures, ...AvailableFeatures[]] = Object.values(AvailableFeatures) as [AvailableFeatures, ...AvailableFeatures[]];

export default AvailableFeatures;

